<div class="login-page" (click)="onContainerClick($event)">
  <!-- Left Side - Login Form -->
  <div class="login-form-container">
    <div class="login-form">
      <!-- Language Selector -->
      <div class="language-selector">
        <app-language-selector></app-language-selector>
      </div>
      <!-- Header with Logo and Language -->
      <div class="form-header">

        <div class="logo-section">
          <!-- <img src="https://placehold.co/200x100/orange/white?text=Dr.%20Piyu\nHeight%20Clinic&font=roboto" alt="DR.Piyu Logo" class="logo"> -->
          <div class="webLogo">
            <img src="./facewithlogo.svg" alt="DR.Piyu Logo" class="logo">
          </div>
          <div class="MobLogo">
            <img src="./mobileLogo.png" alt="DR.Piyu Logo" class="logo">
          </div>
          <!-- <span class="brand-name">DR. Piyu</span> -->
        </div>
      </div>

      <!-- Welcome Section -->
      <div class="welcome-section">
        <!-- <h1>{{ t('welcome') }}</h1> -->
        <p>{{ t('welcome') }}, {{ t('welcomeDesc') }}</p>
      </div>

      <!-- Mobile Number and Password Form -->
      <form [formGroup]="authForm" (ngSubmit)="onSubmit()" class="form">
        <!-- Mobile Field -->
        <div class="form-group">
          <label for="mobile" class="form-label">{{ t('mobileNumber') || 'Mobile Number' }}</label>
          <div class="input-wrapper">
            <i class="fas fa-mobile-alt input-icon"></i>
            <input 
              type="tel" 
              id="mobile" 
              formControlName="mobile"
              [placeholder]="t('mobileNumber') || 'Enter your mobile number'" 
              class="form-input"
              maxlength="10"
              [class.error]="getMobileControl()?.invalid && (getMobileControl()?.dirty || getMobileControl()?.touched)"
            >
          </div>
          <div *ngIf="getMobileControl()?.invalid && (getMobileControl()?.dirty || getMobileControl()?.touched)" class="error-message">
            <div *ngIf="getMobileControl()?.errors?.['required']">{{ t('mobileRequired') || 'Mobile number is required' }}</div>
            <div *ngIf="getMobileControl()?.errors?.['pattern']">{{ t('validMobile') || 'Please enter a valid mobile number' }}</div>
          </div>
        </div>

        <!-- Password Field -->
        <div class="form-group">
          <label for="password" class="form-label">{{ t('password') || 'Password' }}</label>
          <div class="input-wrapper">
            <i class="fas fa-lock input-icon"></i>
            <input 
              [type]="showPassword ? 'text' : 'password'" 
              id="password" 
              formControlName="password"
              [placeholder]="t('password') || 'Enter your password'" 
              class="form-input"
              [class.error]="getPasswordControl()?.invalid && (getPasswordControl()?.dirty || getPasswordControl()?.touched)"
            >
            <button
              type="button"
              class="password-toggle"
              (click)="togglePasswordVisibility()"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
            >
              <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
          </div>
          <div *ngIf="getPasswordControl()?.invalid && (getPasswordControl()?.dirty || getPasswordControl()?.touched)" class="error-message">
            <div *ngIf="getPasswordControl()?.errors?.['required']">{{ t('passwordRequired') || 'Password is required' }}</div>
            <div *ngIf="getPasswordControl()?.errors?.['minlength']">{{ t('passwordMinLength') || 'Password must be at least 6 characters' }}</div>
          </div>
        </div>

        <!-- Submit Button -->
        <button type="submit" class="login-btn btn-primary" [disabled]="isLoading">
          <span *ngIf="!isLoading">{{ t('loginBtn') || 'Login' }}</span>
          <span *ngIf="isLoading">{{ t('loggingIn') || 'Logging in...' }}</span>
        </button>
      </form>



      <!-- Google Sign-in Button -->
      <!-- <button type="button" class="google-btn" (click)="signInWithGoogle()" [disabled]="isLoading" *ngIf="!showOtpInput">
        <svg class="google-icon" width="18" height="18" viewBox="0 0 18 18">
          <path fill="#4285F4" d="M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"/>
          <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"/>
          <path fill="#FBBC05" d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"/>
          <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"/>
        </svg>
        {{ t('continueWithGoogle') }}
      </button> -->

      <!-- Divider -->
      <!-- <div class="divider">
        <span>{{ t('or') }}</span>
      </div> -->

      <!-- Footer -->
      <div class="form-footer">
        <p>{{ t('noAccount') }} <a href="javascript:void(0)" (click)="toggleMode($event)" class="create-account-link">{{
            t('createAccount') }}</a></p>
        <p class="help-text">{{ t('needHelp') }} <a routerLink="/support" class="help-link">{{ t('contactSupport') }}</a></p>
        <p class="admin-link">
          <a routerLink="/" class="admin-login-link">
            <i class="fas fa-house"></i>
            {{ t('home') || 'Home' }}
          </a>
          <a href="javascript:void(0)" class="admin-login-link" (click)="openForgotPasswordModal()">
            <i class="fas fa-key"></i>
            {{ t('forgotPasswordLink') || 'Forgot Password?' }}
          </a>
        </p>
        <!-- <p class="admin-link">
          <a routerLink="/admin/login" class="admin-login-link">
            <i class="fas fa-user-shield"></i>
            Admin Login
          </a>
        </p> -->
      </div>
    </div>
  </div>

  <!-- Right Side - Full Image -->
  <div class="image-container">
    <div class="image-content">
      <div class="overlay-text">
        <h2>{{ t('rightSideTitle') }}</h2>
        <p>{{ t('rightSideDesc') }}</p>
      </div>
    </div>
  </div>
</div>

<!-- User Not Found Modal -->
<app-user-not-found-modal 
  *ngIf="showUserNotFoundModal"
  (closeModal)="closeUserNotFoundModal()"
></app-user-not-found-modal>

<!-- Forgot Password Modal -->
<app-forgot-password-modal
  *ngIf="showForgotPasswordModal"
  (closeModal)="closeForgotPasswordModal()"
></app-forgot-password-modal>